import type { QueryClient } from '@tanstack/vue-query';
import {
  FRAMEWORK_CONFIG_QUERY,
  FRAMEWORK_REQUIREMENTS_QUERY,
} from '@/modules/framework/queryKeys';
import { SUPPLIER_COMPLIANCE_VTWO_QUERY } from './queryKeys';

const REFRESH_ATTEMPTS = 10;
const REFRESH_INTERVAL_MS = 500;

// Backend recalc is event-driven, so refetch repeatedly (~5s) until it lands. Non-blocking.
// Covers both the supplier's compliance and the resolved required-control set (framework
// requirements/config), which the backend recalculates together when labels/tags change.
export function refreshSupplierScopeEventually(queryClient: QueryClient, supplierID: string): void {
  for (let attempt = 1; attempt <= REFRESH_ATTEMPTS; attempt += 1) {
    setTimeout(() => {
      void queryClient.invalidateQueries({
        queryKey: [SUPPLIER_COMPLIANCE_VTWO_QUERY, supplierID],
      });
      // Framework requirements/config are keyed by connectionID (not supplierID),
      // so invalidate at the prefix level to refresh the assessment-scope count.
      void queryClient.invalidateQueries({ queryKey: [FRAMEWORK_REQUIREMENTS_QUERY] });
      void queryClient.invalidateQueries({ queryKey: [FRAMEWORK_CONFIG_QUERY] });
    }, attempt * REFRESH_INTERVAL_MS);
  }
}
